import { FilterTypes } from '../../../../modules/sortAndFilter/workers/sortAndFilter';
import Filter from './Filter';

/**
 * Formats the star rating into a readable string.
 */
export const formatReviewLabel = (rating: number) => {
    if (rating === 5) {
        return '5 stars only';
    }

    const suffix = rating > 1 ? 's' : '';

    return `${rating} star${suffix} and over`;
};

class ReviewFilter extends Filter<number> {
    constructor(type: FilterTypes['type'], urlKey: string) {
        super(type, urlKey);
        this.setKeysFromUrl();
    }

    formatKeysFromUrl = (urlValue: string) => [parseInt(urlValue, 10)];

    currentRating = () => (this.keys.size ? Array.from(this.keys)[0] : 0);

    formatTagLabel = formatReviewLabel;
}

export default ReviewFilter;
